// Author Lin
// Date 2021-07-06 16:42:13

class SithMesInventoryWmDefinition {
constructor({
        id = null,
        warehouseNo = '',
        storageLoc = '',
        storageType = '',
        storageTypeName = '',
        bin = '',
        binNo = '',
        remark = ''}
= {}) {
    this.id = id;
    this.warehouseNo = warehouseNo;
    this.storageLoc = storageLoc;
    this.storageType = storageType;
    this.storageTypeName = storageTypeName;
    this.bin = bin;
    this.binNo = binNo;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesInventoryWmDefinition();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'warehouseNo',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.warehouseNo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'storageLoc',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.storageLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.storageType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'storageTypeName',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.storageTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bin',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.bin',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'binNo',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.binNo',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    warehouseNoFilter : "",
    storageLocFilter : "",
    storageTypeFilter : "",
    storageTypeNameFilter : "",
    binFilter : "",
    binNoFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'warehouseNoFilter',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.filter.warehouseNo',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageLocFilter',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.filter.storageLoc',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.filter.storageType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageTypeNameFilter',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.filter.storageTypeName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'binFilter',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.filter.bin',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'binNoFilter',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.filter.binNo',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'warehouseNo',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.warehouseNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageLoc',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.storageLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'storageTypeName',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.storageTypeName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'bin',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.bin',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'binNo',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.binNo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryWmDefinition.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesInventoryWmDefinition, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
